var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cardlist" },
    [
      _vm.itemsTemplate !== undefined && _vm.itemsTemplate.length > 0
        ? _c(
            "div",
            { staticClass: "mb-2" },
            [
              _c("h5", {
                domProps: { innerHTML: _vm._s(_vm.t.automaticCvTemplate) },
              }),
              _c("hr"),
              _c(
                "b-card-group",
                { attrs: { columns: "" } },
                _vm._l(_vm.itemsTemplate, function (item, index) {
                  return _c("ImageCard", {
                    key: index,
                    attrs: { item: item, selectDesign: _vm.t.selectDesign },
                    on: {
                      selectItem: function ($event) {
                        return _vm.selectItem($event)
                      },
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.itemsExample !== undefined && _vm.itemsExample.length > 0
        ? [
            _c("h5", { domProps: { innerHTML: _vm._s(_vm.t.cvTemplate) } }),
            _c("hr"),
            _c(
              "b-card-group",
              { attrs: { columns: "" } },
              _vm._l(_vm.itemsExample, function (item, index) {
                return _c(
                  "ImageCard",
                  {
                    key: index,
                    attrs: { item: item, selectDesign: _vm.t.selectDesign },
                    on: {
                      selectItem: function ($event) {
                        return _vm.selectItem($event)
                      },
                    },
                  },
                  [
                    _c("b-card-text", {
                      staticClass: "text-center m-0 pt-2 pb-3 text-truncate",
                      domProps: { innerHTML: _vm._s(item.title) },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
          ]
        : _vm._e(),
      _vm.itemsTemplate !== undefined &&
      _vm.itemsTemplate.length === 0 &&
      _vm.itemsExample.length === 0
        ? _c("span", { domProps: { innerHTML: _vm._s(_vm.t.noTemplates) } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }